import React, { useEffect, useRef, useState } from "react";
import { Button, FormControl, Modal } from "react-bootstrap";
import Loader from "../Loader";
import { makeRESTApiRequests } from "../../helpers/api";
import { ENDPOINTS } from "../../helpers/constants";
import { toast } from "react-toastify";
import { getJobTitle } from "../../Util/jobUtil";

export default function JobListModal({ show, onHide, onSelectJob }) {
  const [searchJobTitle, setSearchJobTitle] = useState("");
  const [jobs, setJobs] = useState([]);
  const [loadingJobs, setLoadingJobs] = useState(false);
  const abortControllerRef = useRef(null);

  // Fetch jobs on modal show and on search clear
  useEffect(() => {
    if (show && !searchJobTitle) {
      getJobs();
    }
  }, [show]);

  const getJobs = async (searchTerms = "") => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    const controller = new AbortController();
    abortControllerRef.current = controller;

    setLoadingJobs(true);
    try {
      const { response, error } = await makeRESTApiRequests({
        endpoint: ENDPOINTS.SEARCH_JOBS,
        method: "POST",
        requestBody: {
          query: searchTerms,
          sort: {
            updatedAt: -1,
          },
        },
        signal: controller.signal,
      });

      if (error) {
        toast.error(error);
        return;
      }

      if (response) {
        setJobs(response.results);
      }
    } catch (error) {
      if (error.name !== "AbortError") {
        console.error(error);
        toast.error("Failed to load jobs.");
      }
    } finally {
      setLoadingJobs(false);
    }
  };

  const handleSearch = () => {
    if (!searchJobTitle.trim()) {
      toast.info("Please enter a search term.");
      return;
    }
    getJobs(searchJobTitle.trim());
  };

  return (
    <Modal centered size="md" show={show} onHide={onHide}>
      <Modal.Header closeButton className="py-2 px-3 d-flex align-items-center">
        <div className="w-100 d-flex align-items-center justify-content-between">
          <h6 className="mb-0 small-text">List of Jobs</h6>
        </div>
      </Modal.Header>
      <Modal.Body className="" style={{ height: "400px", overflowY: "auto" }}>
        {loadingJobs ? (
          <Loader />
        ) : (
          <div>
            <div className="d-flex mb-2 gap-2">
              <FormControl
                size="sm"
                placeholder="Enter Job Title"
                value={searchJobTitle}
                onChange={(e) => setSearchJobTitle(e.target.value)}
                onKeyPress={(event) => {
                  if (event.key === "Enter") {
                    handleSearch();
                  }
                }}
              />
              <Button size="sm" onClick={handleSearch}>
                Search
              </Button>
            </div>
            <div className="d-flex flex-column gap-3">
              {jobs.length > 0 ? (
                jobs.map((job) => (
                  <h6
                    key={job._id}
                    className="mb-0 small border rounded p-2 hover-light"
                    onClick={() => onSelectJob(job)}
                  >
                    {getJobTitle(job)}
                  </h6>
                ))
              ) : (
                <p>No jobs available</p>
              )}
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}
